import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { forkJoin } from 'rxjs';
import { ApiResponse } from 'src/app/shareModule/models/common.model';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { LocalServiceService } from 'src/app/shareModule/services/local-service.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-manage-category',
  templateUrl: './manage-category.component.html',
  styleUrls: ['./manage-category.component.scss']
})
export class ManageCategoryComponent implements OnInit {

  public assignCategoryList: Array<any> = [];
  public assignInterestList: Array<any> = [];
  public allInterestList: Array<any> = [];
  public allCategoryList: Array<any> = [];
  public allCategoryListWithSubCategory: Array<any> = [];
  public selectedCategory: any;
  public commonModal: any = null;
  public categoryName: string = '';
  public categoryImage: string = '';
  public categoryBannerImage: string = '';
  public categoryTitle: string = '';
  public categoryContent: string = '';
  public categoryMeta: string = '{}';
  public codeSchema = ''
  public bottomText = ''


  public imgUrl = environment.ImageUrl;
  public imageBase64: string | ArrayBuffer;
  public imageBase64Banner: string | ArrayBuffer;
  public selMenu = 'sub-category';
  public formMenu = 'main';

  public selectedPromoFile: File | null = null;
  public encodedPromoFile: ArrayBuffer | string | null = null;

  constructor(private auth: AuthServiceService, private modalService: NgbModal, private toastr: ToastrService, private local: LocalServiceService) { }

  ngOnInit(): void {
    this._getAllCategoryList();
  }

  public addCategory(modal: any, selected: any = null) {
    console.log({ selected })

    if (selected) {
      this.categoryName = selected?.name;
      this.categoryTitle = selected?.title;
      this.categoryContent = selected?.content;
      this.categoryMeta = selected?.metaConfig;
      this.codeSchema = selected?.codeSchema;
      this.bottomText = selected?.bottomText
      this.categoryImage = selected?.image;
      this.categoryBannerImage = selected?.bannerImage;
      this.selectedCategory = selected;
      this.promoRedirectURL = selected?.promoRedirectURL;
      const faqInfos = JSON.parse(selected?.faqInfos ?? "{}");

      this.questionOne = faqInfos['questionOne']
      this.answerOne = faqInfos['answerOne'];

      this.questionTwo = faqInfos['questionTwo']
      this.answerTwo = faqInfos['answerTwo'];

      this.questionThree = faqInfos['questionThree']
      this.anserThree = faqInfos['answerThree'];

      this.questionFour = faqInfos['questionFour']
      this.anserFour = faqInfos['answerFour'];

      this.questionFive = faqInfos['questionFive']
      this.anserFive = faqInfos['answerFive'];




    } else {
      this.selectedCategory = null;
      this.categoryName = "";
      this.categoryTitle = ""
      this.categoryContent = ""
      this.categoryMeta = ""
      this.codeSchema = ''
      this.bottomText = '';
    }

    this.commonModal = this.modalService.open(modal, { size: "sm", ariaLabelledBy: "modal-basic-title", backdrop: "static" });

  }

  public openAssign(modal: any, selected: any) {

    this.assignCategoryList = this.allCategoryList.map((i) => {
      return { ...i, checked: (selected.subCategory.filter(j => j.categorieChildId == i.id).length > 0) };
    })

    this.selectedCategory = selected;
    this.commonModal = this.modalService.open(modal, { size: "sm", ariaLabelledBy: "modal-basic-title", backdrop: "static" });
  }

  public toggleRoleOnSubCategory(subCategory) {
    if (subCategory.isCategoryARole) {
      this.local.confirmYesNo(
        {
          title: 'Turn off role?',
          text: 'Are you sure you want to turn off role from this subcategory?',
          icon: 'warning'
        }

      ).then(
        val => {
          if (val.isConfirmed) {
            console.log(subCategory)
            this.auth.toggleIsRoleOnOffOnCategory(subCategory.categorieChildId)
              .subscribe({
                next: (data) => {
                  subCategory.isCategoryARole = !subCategory.isCategoryARole
                },
                error: (err) => {
                  console.error(err);
                  this.toastr.error("Error something went wrong")
                }
              })

          } else {
            this.toastr.info("Turning off role cancelled")

          }
        }
      )

    } else {
      // this.local.confirmYesNo(
      //   {
      //     title: 'Turn on role?',
      //     text: 'Are you sure you want to turn on role from this subcategory?',
      //     icon: 'info'
      //   }

      // ).then(
      //   val=>{
      //     if(val.isConfirmed){
      //       this.auth.toggleIsRoleOnOffOnCategory(subCategory.categorieChildId)
      //       .subscribe({
      //         next: (data)=>{
      //           subCategory.isCategoryARole = !subCategory.isCategoryARole
      //         },
      //         error: (err)=>{
      //           console.error(err);
      //           this.toastr.error("Error something went wrong")
      //         }
      //       })

      //     }else{
      //       this.toastr.info("Turning on role cancelled")

      //     }
      //   }
      // )
      this.currentSelectedSubCatForEdit = subCategory
      this.currentRoleName = subCategory.roleName ?? ''
      this.modalService.dismissAll();
      const modalRef = this.modalService.open(this.roleNameModal)



    }


  }

  @ViewChild('roleNameModal')
  public roleNameModal: any;

  public currentSelectedSubCatForEdit: any = {};
  public currentRoleName = ''

  public onRoleNameChange(e) {
    this.currentSelectedSubCatForEdit.roleName = e.target.value

  }
  /********************** code related to subcategory type******************************/
  @ViewChild('addNewType')
  public addNewTypeModal: ElementRef;


  public cates = new Set();
  private _registerCats(cats){
    this.cates = new Set();
    for(const cat of cats){
      if(cat?.subCategory?.length){
        this.cates.add(cat.id)
      }
    }

  }
  
  public currentlyChangingNameOfTypeGrouping; //this is the number like the '1' in type 1
  public currentlyChangingNameOfTypeGroupingName = '';
  public currenylyChangingNameOfSubCategoryId;

  @ViewChild('changeTypeGrouingName')
  public changeTypeGrouingNamePopup : ElementRef;

  public openChangeTypeGroupingNamePopup(subcategoryId, typeNum){
    this.currentlyChangingNameOfTypeGrouping = typeNum;
    this.currenylyChangingNameOfSubCategoryId = subcategoryId;
    this.modalService.open(this.changeTypeGrouingNamePopup, {size: 'md'})
  }
  
  public saveCustomTypeGroupingName(){
    this.auth.setTypeGroupingName(this.currentlyChangingNameOfTypeGrouping, this.currentlyChangingNameOfTypeGroupingName, this.currenylyChangingNameOfSubCategoryId)
    .subscribe({
      next: ()=>{
        this.modalService.dismissAll();
        this.toastr.success("Changed");
        this._getAllCategoryList();
      },
      error: err =>{
        console.error(err);
        this.toastr.error("Error something went wrong while chaning ")
      }
    })
  }

  private addingNewTypeToSubCagtegoryId;
  public newSubCategoryTypeName = '';
  public newSubCategoryType = 1; //this decides if the type is 1 or 2

  public typeCustomNamesMapping = new Map<string, string>; //subcategoryId x typeNumber as key, customname as value


  private _setTypeNames(categories){
    for(const cat of categories){
      for(const customTypeName of cat.subCategoryTypeGroupingNames){
        const KEY = `${cat.id}x${customTypeName.typeNumber}`
        this.typeCustomNamesMapping[KEY] = customTypeName.typeName
      }

    }

  }



  public showAddNewTypeModal(subCagtegoryId) {
    console.log({subCagtegoryId})
    this.addingNewTypeToSubCagtegoryId = subCagtegoryId;
    this.modalService.open(this.addNewTypeModal, { size: 'md' })
  }

  public removeType(type) {
    this.local.confirmYesNo({
      icon: 'warning',
      title: 'Remove type:' + type.name,
      text: 'Remove type:' + type.name
    }).then(
      c => {
        if (c.isConfirmed) {
          this.auth.deleteSubCategoryType(type.id).subscribe(
            {
              next: () => {
                this._getAllCategoryList();
                this.toastr.success("Type Removed")
              },
              error: err => {
                console.error(err);
                this.toastr.error("Error something went wrong")
              }
            }
          )
        }
      }
    )

  }
  public createNewType() {
    this.auth.createSubCategoryType(this.newSubCategoryTypeName, Number(this.newSubCategoryType), this.addingNewTypeToSubCagtegoryId).subscribe(
      {
        next: () => {
          this.addingNewTypeToSubCagtegoryId = '';
          this.newSubCategoryTypeName = '';
          this.toastr.success("Created!");
          this._getAllCategoryList();
          this.modalService.dismissAll();
        },
        error: err => {
          this.addingNewTypeToSubCagtegoryId = '';
          console.error(err);
          this.toastr.error("Error something went wrong while adding")
        }
      }
    )


  }





  public saveCurrentRole() {
    this.auth.toggleIsRoleOnOffOnCategory(this.currentSelectedSubCatForEdit.categorieChildId, this.currentRoleName ?? '')
      .subscribe({
        next: (data) => {
          this.currentSelectedSubCatForEdit.roleName = (this.currentRoleName ?? '')
          this.currentSelectedSubCatForEdit.isCategoryARole = !this.currentSelectedSubCatForEdit.isCategoryARole
          this.allCategoryList = [...this.allCategoryList]
          this.toastr.success("roleName changed")
          this.currentRoleName = ''
        },
        error: (err) => {
          console.error(err);
          this.toastr.error("Error something went wrong")
        }
      })

  }


  public openAssignInterest(modal: any, selected: any) {
    let selectedId = selected?.tag.map(i => i.interest.id) || [];
    this.assignInterestList = this.allInterestList.map((i) => {
      return { ...i, checked: false };
    }).filter((i) => !selectedId.includes(i.id));

    this.selectedCategory = selected;
    this.commonModal = this.modalService.open(modal, { size: "sm", ariaLabelledBy: "modal-basic-title", backdrop: "static" });
  }


  private _getAllCategoryList() {
    this.auth.getAllMemberCategorieRelationship().subscribe((resp: ApiResponse) => {
      this.allCategoryList = resp.body;
      this._registerCats(this.allCategoryList)
    })

    this.auth.getAllCategorieTag().subscribe((resp: ApiResponse) => {
      this.allCategoryListWithSubCategory = resp.body;
      this._setTypeNames(this.allCategoryListWithSubCategory)
    });

    this.auth.getAllMemberSurveyInterest().subscribe((resp: ApiResponse) => {
      this.allInterestList = resp.body;
    })


  }

  public removeRelationship(id) {
    this.auth.deleteMemberCategorieRelationship(id).subscribe((resp: ApiResponse) => {
      this.toastr.success(resp.message);
      this._getAllCategoryList();
    })
  }

  public removeInterest(id) {
    this.auth.deleteCategorieTag(id).subscribe((resp: ApiResponse) => {
      this.toastr.success(resp.message);
      this._getAllCategoryList();
    })
  }

  public assignRelationshipSubmit(modal: any) {
    let apiList = [];
    this.assignCategoryList.filter(i => i.checked).map((i) => {
      if (this.selectedCategory.id != i.id && (this.selectedCategory.subCategory.filter(j => j.categorieChildId == i.id).length == 0)) {
        apiList.push(this.auth.addMemberCategorieRelationship({ categorieParentId: this.selectedCategory.id, categorieChildId: i.id }));
      }
    });

    if (apiList && apiList.length > 0) {
      forkJoin(apiList).subscribe((resp: any) => {
        this.toastr.success(resp[0].message);
        this._getAllCategoryList();
        this.commonModal.close();
      });
    }
  }


  public assignInterestRelationshipSubmit(modal: any) {
    let apiList = [];
    this.assignInterestList.filter(i => i.checked).map((i) => {
      // if (this.selectedCategory.id != i.id && (this.selectedCategory.subCategory.filter(j => j.categorieChildId == i.id).length == 0)) {
      apiList.push(this.auth.addCategorieTag({ categorieId: this.selectedCategory.id, tagId: i.id }));
      //  }
    });

    if (apiList && apiList.length > 0) {
      forkJoin(apiList).subscribe((resp: any) => {
        this.toastr.success(resp[0].message);
        this._getAllCategoryList();
        this.commonModal.close();
      });
    }
  }

  @ViewChild('uploadPromoImage')
  uploadPromoImage: any;

  promoRedirectURL = '';

  //new feilds are below
  public questionOne = '';
  public answerOne = '';

  public questionTwo = '';
  public answerTwo = '';

  public questionThree = '';
  public anserThree = '';

  public questionFour = '';
  public anserFour = '';

  public questionFive = '';
  public anserFive = '';


  public AddEditCategorySubmit() {
    let formData = new FormData();
    typeof this.categoryImage == "string" ? "" : formData.append("image", this.categoryImage);
    typeof this.categoryBannerImage == "string" ? "" : formData.append("bannerImage", this.categoryBannerImage);

    formData.append("name", this.categoryName.trim());
    // formData.append("title", this.categoryTitle)
    formData.append("promoFile", this.selectedPromoFile);;
    formData.append("promoRedirectURL", this.promoRedirectURL)
    formData.append("content", this.categoryContent)


    //new feilds related to subcategory FAQ
    formData.append('faqInfos', JSON.stringify({
      questionOne: this.questionOne,
      answerOne: this.answerOne,

      questionTwo: this.questionTwo,
      answerTwo: this.answerTwo,

      questionThree: this.questionThree,
      answerThree: this.anserThree,

      questionFour: this.questionFour,
      answerFour: this.anserFour,

      questionFive: this.questionFive,
      answerFive: this.anserFive
    }));

    formData.append("metaConfig", this.categoryMeta)
    formData.append('codeSchema', this.codeSchema);
    formData.append('bottomText', this.bottomText)

    let api = this.auth.addMemberProductCategory(formData);

    if (this.selectedCategory) {
      formData.append("id", this.selectedCategory?.id);
      api = this.auth.updateMemberCategoryInfo(formData)
    }

    api.subscribe((resp: ApiResponse) => {
      this.toastr.success(resp.message);
      this.commonModal ? this.commonModal.close() : '';
      this._getAllCategoryList();
      this.categoryName = '';
      this.categoryMeta = '{}'; //invalid json everytime!
      this.codeSchema = ''
      this.bottomText = ''
      this.categoryImage = '';
      this.categoryBannerImage = '';
      this.selectedCategory = null;
      this.imageBase64 = null;
      this.imageBase64Banner = null;
      this.selectedPromoFile = null;
      this.encodedPromoFile = null;
      this.questionFive = '';
      this.questionFour = '';
      this.questionThree = '';
      this.questionTwo = '';
      this.questionOne = '';

      this.answerOne = '';
      this.anserFive = '';
      this.anserFour = '';
      this.anserThree = '';
      this.answerTwo = '';

    }, ({ error }) => {
      this.toastr.error(error.message);
    });

  }

  public deleteCategory(id: any) {
    this.auth.deleteShopProductCategory({ categoryId: id }).subscribe((resp: ApiResponse) => {
      this.toastr.success(resp.message);
      this.commonModal ? this.commonModal.close() : '';
      this._getAllCategoryList();
    })
  }

  public promoBannerChange(e) {
    const file = e.target.files[0]
    const reader = new FileReader();
    reader.onload = () => {
      this.selectedPromoFile = file;
      this.encodedPromoFile = reader.result;
    }
    reader.readAsDataURL(file);


  }

  public saveProductCharSelectedImage(event, isBanner = false) {
    this.selectedCategory ? (this.selectedCategory[isBanner ? 'bannerImage' : 'image'] = null) : "";
    let file = event.target.files[0];
    let fileReader = new FileReader();
    fileReader.onload = () => {
      if (!isBanner) {
        this.imageBase64 = fileReader.result;
        this.categoryImage = file;
      } else {
        this.imageBase64Banner = fileReader.result;
        this.categoryBannerImage = file;
      }
    };
    fileReader.readAsDataURL(file);
  }

  public selectMenu(menu: string) {
    this.selMenu = menu;
  }

}
